<template>
	<q-page padding>
		<q-tabs
			v-model="tab"
			color="white"
			text-color="primary"
			underline-color="primary"
			class="shadow-1 bg-white"
			align="justify"
		>
			<q-route-tab
				slot="title"
				name="trainings"
				:label="$t('online')"
				icon="fas fa-globe"
				:to="{ name: 'courses' }"
				v-if="has_courses"
			/>
			<q-tab
				slot="title"
				name="presential"
				:label="$t(title_presential)"
				icon="fas fa-chalkboard-teacher"
				:to="{ name: 'presential' }"
				v-if="has_presential"
			/>

			<q-tab-pane name="presential" class="q-px-md q-pb-xl q-mt-md">
				<div class="row gutter-sm">
					<div :class="filterClass">
						<filter-presential @changeFilter="changeFilter" />
					</div>

					<div :class="contentClass" style="min-height: 700px;">
						<div class="row gutter-md">
							<div class="col-12">
								<q-infinite-scroll
									:handler="loadPresential"
									:offset="10"
									ref="presential_scroll"
								>
									<div class="row gutter-md">
										<div
											class="col-xs-12 col-sm-12"
											v-for="(presential, index) in presentials"
											:key="index"
										>
											<card-desktop
												:presential="presential"
												:current_client="current_client"
												v-if="$q.platform.is.desktop"
												:key="presential.id"
												@clickLike="clickLike"
												@clickStars="clickStars"
												@clickFavorite="clickFavorite"
												@showCourseInfo="showCourseInfo"
												@showCertificate="showCertificate"
											/>

											<card-mobile
												:presential="presential"
												:current_client="current_client"
												v-if="$q.platform.is.mobile"
												:key="presential.id"
												@clickLike="clickLike"
												@clickStars="clickStars"
												@clickFavorite="clickFavorite"
												@showCourseInfo="showCourseInfo"
												@showCertificate="showCertificate"
											/>
										</div>

										<div
											class="col-xs-12 col-sm-12"
											v-if="presentials.length === 0 && !has_next_page"
										>
											<q-card>
												<q-card-title>
													{{ $t('no_presential_courses_found') }}
												</q-card-title>
												<q-card-separator />
												<q-card-main
													v-if="
														this.search ||
															this.favorite != 'all' ||
															this.progress != 'all'
													"
												>
													{{ $t('searched_term_returned_no_results') }}
												</q-card-main>
												<q-card-main v-else>
													{{
														$t(
															'there_are_no_presential_courses_avaliable_at_the_moment'
														)
													}}
												</q-card-main>
											</q-card>
										</div>
									</div>

									<div class="text-center q-mt-xl">
										<q-spinner-dots
											slot="message"
											:size="40"
											v-if="has_next_page"
										></q-spinner-dots>
									</div>
								</q-infinite-scroll>
							</div>
						</div>
					</div>
				</div>
			</q-tab-pane>
		</q-tabs>

		<modal-stars :show="show_modal" :presential="presential" @hideModal="hideModal" />

		<modal-course-info
			v-if="show_course_info"
			:show="show_course_info"
			:presential="presential"
			@hideCourseInfo="hideCourseInfo"
		/>

		<certificate
			:show="show_certificate"
			:data="certificate_data"
			:certificate="certificate"
			@hideCertificate="hideCertificate"
		/>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Filter from 'components/presential/Filter'
import CardDesktop from 'components/presential/CardDesktop'
import CardMobile from 'components/presential/CardMobile'
import ModalStars from 'components/presential/ModalStars'
import Certificate from 'components/Certificate'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'presential'] },

	data() {
		return {
			tab: 'presential',
			presentials: [],
			presential: [],
			presential_event_user_result_status: null,
			presential_event_user_result_percent: null,
			presential_event_user_result_date: '',
			certificate_data: {},
			show_certificate: false,
			page: 1,
			has_next_page: true,
			certificate: {},
			show_modal: false,
			show_course_info: false,
			current_client: '',
		}
	},

	components: {
		'filter-presential': Filter,
		'card-desktop': CardDesktop,
		'card-mobile': CardMobile,
		'modal-stars': ModalStars,
		'modal-course-info': () => import('components/presential/ModalCourseInfo'),
		certificate: Certificate,
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			reload_content: 'common/reload_content',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
			search: 'presential/search',
			progress: 'presential/progress',
			favorite: 'presential/favorite',
			id_user_language_selected: 'common/id_user_language_selected',
			user_id: 'common/id',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		title_presential() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					return obj.title_presential == '' ? 'presential' : obj.title_presential
				}
			}
		},

		filterClass() {
			if (this.$q.platform.is.ipad) return 'col-12'
			else return 'col-xs-12 col-sm-3'
		},

		contentClass() {
			if (this.$q.platform.is.ipad) return 'col-12'
			else return 'col-xs-12 col-sm-9'
		},

		has_courses() {
			let obj = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj && obj.has_courses) return true
			else return false
		},

		has_presential() {
			let obj = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj && obj.has_presential) return true
			else return false
		},
	},

	methods: {
		loadPresential(index, done) {
			if (this.has_next_page) {
				let data = {
					page_size: 5,
					page: this.page,
					search: this.search,
					favorited: this.favorite === 'all' ? false : true,
				}

				if (this.progress !== 'all') data.progress = this.progress

				this.$axios
					.get(
						'/etraining_presential/presential/?' +
							this.$qs.stringify(data, { arrayFormat: 'repeat' }),
						this.getHeader
					)
					.then((response) => {
						response.data.results.map((p) => {
							let title = p.code ? `${p.code} - ${p.title}` : p.title

							let image_small = ''
							let image_thumb = ''

							let obj = p.presential_event_images.find((obj) => {
								return obj.name === 'thumbnail'
							})
							if (obj) image_thumb = obj.image_url

							obj = p.presential_event_images.find((obj) => {
								return obj.name === 'small'
							})
							if (obj) image_small = obj.image_url

							let vacancies = p.qty_vacancies

							let push = p
							push.title = title
							push.image_small = image_small
							push.image_thumb = image_thumb
							push.vacancies = vacancies

							this.presentials.push(push)
						})

						if (!this.current_client) this.setCurrentClient()

						if (!response.data.next || response.data.results.length === 0)
							this.has_next_page = false
						else this.page++
					})
					.catch((e) => {
						this.has_next_page = false
						console.log(e)
					})
					.finally(() => {
						done()
					})
			}
		},

		fetchLists() {
			this.$q.loading.show()

			this.$axios
				.get('/accounts/get_site_registration_lists/', this.getHeader)
				.then((response) => {
					this.$store.dispatch('site_lists/SET_LISTS', [response.data])
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		changeFilter() {
			this.has_next_page = true
			this.presentials = []
			this.page = 1

			if (this.$refs.presential_scroll) {
				this.$refs.presential_scroll.stop()
				this.$refs.presential_scroll.resume()
				this.$refs.presential_scroll.loadMore()
			}
		},

		clickLike(id) {
			let obj = this.presentials.find((obj) => {
				return obj.id === id
			})

			if (obj) {
				if (obj.liked) obj.likes--
				else if (!obj.liked) obj.likes++

				obj.liked = !obj.liked
			}

			let fd = new FormData()

			this.$axios
				.post(
					`/etraining_presential/presential/${id}/like_presential_event/`,
					fd,
					this.getHeader
				)
				.then((response) => {
					obj.likes = response.data.likes
				})
				.catch((e) => {
					console.log(e)
				})
		},

		clickStars(id) {
			let obj = this.presentials.find((obj) => {
				return obj.id === id
			})

			if (obj) {
				this.presential = obj
				this.show_modal = true
			}
		},

		hideModal(type) {
			if (type == 'commented') {
				this.presential.starred = true
			}
			this.show_modal = false
		},

		showCourseInfo(course) {
			let obj = this.presentials.find((obj) => {
				return obj.id === course.id
			})

			if (course) {
				this.presential = course
				this.show_course_info = true
			}
		},

		hideCourseInfo() {
			this.show_course_info = false
		},

		clickFavorite(id) {
			let obj = this.presentials.find((obj) => {
				return obj.id === id
			})

			if (obj) {
				obj.favorited = !obj.favorited
			}

			let fd = new FormData()

			this.$axios
				.post(
					`/etraining_presential/presential/${id}/set_presential_event_user_favorite/`,
					fd,
					this.getHeader
				)
				.then((response) => {
					obj.favorited = response.data.favorited
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		openFile(file_url) {
			if (this.$q.platform.is.cordova && this.$q.platform.is.ios) {
				cordova.InAppBrowser.open(
					file_url,
					'_system',
					'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no'
				)
			} else {
				window.open(file_url, '_blank')
			}
		},

		showCertificate(id) {
			let obj = this.presentials.find((obj) => {
				return obj.id === id
			})

			this.$q.loading.show()

			let fd = new FormData()
			fd.append('user_id', this.user_id)

			this.$axios
				.get(
					`/etraining_presential/presential/${id}/get_presential_event_user_result_certificate/`,
					fd,
					this.getHeader
				)
				.then((response) => {
					this.certificate = { group_training_title: obj.title }
					this.certificate_data = response.data
					this.show_certificate = true
					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		hideCertificate() {
			this.show_certificate = false
			this.certificate_data = []
		},

		setCurrentClient() {
			this.current_client = process.env.PROJECT_FOLDER
		},
	},

	watch: {
		reload_content: function() {
			this.fetchAll()
			this.changeFilter()
		},
	},

	created() {
		this.fetchLists()
		this.setCurrentClient()
	},
}
</script>

<style></style>
